/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* Configuration for a StackAdapt campaign's goal settings
*/
export class V3StackAdaptCampaignGoal {
    /**
    * List of goals for the campaign
    */
    'goals'?: Array<any>;
    /**
    * Whether the first goal is strict
    */
    'isFirstGoalStrict'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "goals",
            "baseName": "goals",
            "type": "Array<any>",
            "format": ""
        },
        {
            "name": "isFirstGoalStrict",
            "baseName": "isFirstGoalStrict",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptCampaignGoal.attributeTypeMap;
    }

    public constructor() {
    }
}

